import type { ReactNode } from "react";

import { Card } from "./card";

/** One key number on a detail page: a label, the value, and an optional line under it. */
export function Stat({ label, value, detail }: { label: ReactNode; value: ReactNode; detail?: ReactNode }) {
  return (
    <Card className="flex min-w-0 flex-col gap-2 p-4 sm:p-5">
      <span className="flex items-center gap-1 text-[13px] font-semibold text-muted">{label}</span>
      <span className="tabular text-2xl leading-none font-extrabold tracking-tight">{value}</span>
      {detail && <span className="text-[13px] text-ink-2">{detail}</span>}
    </Card>
  );
}
